import { render, staticRenderFns } from "./PrestationSelectorModal.vue?vue&type=template&id=117799c8"
import script from "./PrestationSelectorModal.vue?vue&type=script&lang=js"
export * from "./PrestationSelectorModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports